import styled from '@emotion/styled'

import { LinkButton, Space } from '../../../../../components/core-v2'
import PillLabel from '../../../../../components/core-v2/atoms/pillLabel/PillLabel'
import { AssetResult } from '../state/portfolio-slice'

const StyledTable = styled.table`
  width: 100%;
  font-weight: normal;
  border-collapse: collapse;

  th {
    font-weight: normal;
    padding: 24px 10px;
    background-color: var(--White98);
    text-align: left;
    border-top: 1px solid var(--White94);
    border-bottom: 1px solid var(--White94);
  }

  .name {
    border-left: none;
    button {
      font-weight: 600;
    }
  }

  .classification {
    text-align: right;
    border-right: none;
  }

  td {
    border: 1px solid var(--White96);
    padding: 24px 10px;
    line-height: 1.7em;
    button {
      text-align: left;
    }
  }
`

type AssetsTableProps = {
  assets: AssetResult[]
  onClickAsset: (id: string) => void
}

export const AssetsTable = ({ assets, onClickAsset }: AssetsTableProps) => (
  <StyledTable>
    <thead>
      <tr>
        <th className="name">{assets.length} Assets available</th>
        <th>Type</th>
        <th className="protection-class">Protection class</th>
        <th className="tax-class">Tax classification</th>
        <th className="asset-class">Asset class</th>
        <th className="asset-class">Status</th>
      </tr>
    </thead>
    <tbody>
      {assets.map(a => (
        <tr key={a.name}>
          <td className="name">
            <Space mb={2}>
              <LinkButton
                underline
                disabled={!a.isMarketDataReady}
                onClick={() => onClickAsset(a.id)}
              >
                {a.name}
              </LinkButton>
            </Space>
            {a.id}
          </td>
          <td>{a.assetType}</td>
          <td className="protection-class">{a.protectionType}</td>
          <td className="tax-class">{a.taxClassification}</td>
          <td className="asset-class">{a.assetClass}</td>
          <td className="asset-class">
            <PillLabel>
              {a.isMarketDataReady ? 'Market data ready' : 'Insufficient market data'}
            </PillLabel>
          </td>
        </tr>
      ))}
    </tbody>
  </StyledTable>
)
